import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

/** Stops the Annual Plan V2 chunk from loading, even by URL, wherever `features.annualPlanV2` is off. */
@Injectable({ providedIn: 'root' })
export class AnnualPlanFeatureFlagGuard implements CanLoad {
  constructor(private readonly environment: EnvironmentConfiguration, private readonly router: Router) {}

  canLoad(): boolean {
    if (this.environment.features && this.environment.features.annualPlanV2) {
      return true;
    }
    this.router.navigate(['/annual-plan-home']);
    return false;
  }
}
